var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"tile":"","no-body":_vm.noBody}},[_c('b-card-title',{staticClass:"d-flex bg-primary bg-soft align-items-center px-2 py-2 mb-3"},[_c('div',{staticClass:"h4 mb-0 text-primary"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('div',{staticClass:"flex-grow-1"}),_vm._t("action")],2),_c('div',{staticClass:"px-2"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }